import React, { useEffect, useState } from 'react';

import CButton from '../button/button';
import CInput from '../input/input';
import { Line, Space } from '../utils/utils';

import '../../theme/global.scss';
import { notify } from '../../notifications/notification';
import { editObservations } from '../../network/measure';

interface IObservations {
  idMeasure: number;
  callback: () => any;
  observations: string;
  readOnly: boolean;
}

const EditObservations = (props: IObservations) => {
  const [observations, setObservations] = useState('');

  useEffect(() => {
    setObservations(props.observations);
  }, [props.observations]);

  const handleSubmit = (event: React.MouseEvent) => {
    event.preventDefault();
    if (observations.length === 0) {
      notify('Nu ati completat campul de observatii', 'warning');
    } else {
      editObservations(props.idMeasure, observations).then(() => {
        props.callback();
      });
    }
  };

  return (
    <form>
      <p className='body-dark bold'>Observații</p>
      <Line width={'80px'} />
      <Space vertical={'30px'} />
      {props.readOnly ?
        props.observations && props.observations.length > 0 ? <p className="small-dark">{observations}</p> : <p className="small-dark info">Nu au fost adăugate observații.</p>
        :
        <CInput
          label='Descriere'
          type='textarea'
          id='observations'
          placeholder='Descriere'
          name='observations'
          value={observations}
          onChange={e => setObservations(e.target.value)}
          required
          disabled={props.readOnly}
        />
      }
      <Space vertical={'30px'} />
      {!props.readOnly && (
        <CButton label='Adaugă' type='submit' onClick={handleSubmit} />
      )}
    </form>
  );
};

export default EditObservations;
